<template>
  <div class="loading-animation-mask" v-show="isShow">
    <div class="loading-animation-content">
      <!-- <img class="loading-animation-icon" src="@/assets/img/loading/waiting.gif">  -->
      <Icon class="loading-animation-icon" type="ios-loading"/>
      {{text}}
    </div>
  </div>
</template>

<script>
import {Icon} from 'view-design'
export default {
  name:'loading-animation-mask',
  components:{
    Icon
  },
}
</script>
<style>
  .loading-animation-mask{
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.2);
    z-index: 10000;
  }
  .loading-animation-content{
    width: 150px;
    height: 50px;
    line-height: 50px;
    background-color:  rgba(0,0,0,0.5);
    color: #ccc;
    text-align: center;
    vertical-align: middle;
    border-radius: 5px;
  }
  @keyframes rotateIcon{
    from{
      transform: rotate(0);
    }
    to{
      transform: rotate(360deg);
    }
  }

  @-webkit-keyframes rotateIcon{
    from{
      transform: rotate(0);
    }
    to{
      transform: rotate(360deg);
    }
  }
  @-ms-keyframes rotateIcon{
    from{
      transform: rotate(0);
    }
    to{
      transform: rotate(360deg);
    }
  }
  @-moz-keyframes rotateIcon{
    from{
      transform: rotate(0);
    }
    to{
      transform: rotate(360deg);
    }
  }
  .loading-animation-icon{
    animation: rotateIcon 1s linear infinite;
    -webkit-animation: rotateIcon 1s linear infinite;
    -ms-animation: rotateIcon 1s linear infinite;
    -moz-animation: rotateIcon 1s linear infinite;
  }
  
</style>